export const articles = [
  {
    slug: "autumn-manga-2026",
    title: "2026年秋、いま読むべき男性向け漫画5選",
    excerpt:
      "秋の新刊から、編集部が実際に読み返した作品だけを選びました。長編と短編をバランスよく紹介します。",
    category: "編集部レビュー",
    publishedAt: "2026-10-10",
    updatedAt: "2026-10-15",
    imageUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20artwork%20of%20stacked%20manga%20volumes%20in%20steel%20blue%20and%20warm%20sand%20tones%2C%20soft%20geometric%20shapes%20and%20paper%20texture%2C%20clean%20minimal%20magazine%20cover%20style%20composition%2C%20no%20text&width=1200&height=675&seq=art-01&orientation=landscape",
    body: [
      "秋は新刊が集中する季節です。書店に並ぶ作品数が増えるぶん、どれから読むか迷ってしまう人も多いのではないでしょうか。今回は、ユメサーチの編集部が実際に読み返した作品の中から、男性向け漫画を5作品紹介します。",
      "選定の基準は「読み終えたあとに何かが残るか」です。派手な展開があるかどうかよりも、人物の描き方や台詞の温度感を重視しました。長編シリーズと読み切り、それぞれの良さが伝わる構成にしています。",
      "まず挙げたいのは「鋼鉄のレクイエム」です。戦いのあとの静かな時間を丁寧に描いており、アクションだけでなく喪失の物語として読めます。シリーズものですが、1巻から十分に成立しています。",
      "短編で気軽に読みたい方には「廃線駅の幽霊」がおすすめです。ホラーではありますが、驚かせることよりも空気感を大切にした作品で、読後にしばらく余韻が残ります。",
      "長編をじっくり読みたい方には「剣客ふたたび」を。王道の時代劇でありながら、主人公の迷いが丁寧に描かれています。すでに刊行が進んでいるため、まとめて読みたい人に向いています。",
      "ユメサーチでは、こうした紹介記事とあわせて、作品ごとの基本情報やレビュー評価も確認できます。気になった作品は詳細ページからタグをたどって、似ている作品を探してみてください。",
    ],
    relatedWorkIds: ["WK-0002", "WK-0007", "WK-0009", "WK-0012", "WK-0005"],
  },
  {
    slug: "ebook-guide-female",
    title: "女性向け電子書籍の選び方——失敗しないための3つの基準",
    excerpt:
      "表紙とあらすじだけで決めないために。試し読み、短編集か長編か、価格帯の考え方を整理しました。",
    category: "選び方ガイド",
    publishedAt: "2026-09-28",
    updatedAt: "2026-10-08",
    imageUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20artwork%20of%20an%20open%20ebook%20on%20a%20linen%20surface%20in%20blush%20rose%20and%20cream%20tones%2C%20soft%20shadows%20and%20paper%20grain%2C%20minimal%20lifestyle%20magazine%20composition%2C%20no%20text&width=1200&height=675&seq=art-02&orientation=landscape",
    body: [
      "電子書籍は表紙とあらすじだけでは中身が分かりにくい、という声をよく聞きます。そこで今回は、失敗を減らすために見ておきたい3つの基準を整理しました。",
      "1つ目は「試し読みの分量」です。ユメサーチの詳細ページでは、あらすじと作品情報をまとめて確認できます。文章のテンポが自分に合うかどうかは、最初の数ページで判断するのが確実です。",
      "2つ目は「短編集か長編か」です。短編集は1話ごとに区切りがあるため、移動中や寝る前の読書に向いています。長編は世界観に浸れる反面、まとまった時間が必要です。生活スタイルから選ぶと後悔が少なくなります。",
      "3つ目は価格帯の考え方です。安さだけで選ぶと、続巻を買う前提の作品で結果的に高くつくことがあります。シリーズものは、1巻あたりの価格と刊行ペースをあわせて確認しておきましょう。",
      "ユメサーチでは、価格帯やシリーズの有無で絞り込める詳細検索を用意しています。「500円未満」「シリーズ作品のみ」などの条件を組み合わせてみてください。",
    ],
    relatedWorkIds: ["WK-0015", "WK-0019", "WK-0021", "WK-0026"],
  },
  {
    slug: "sample-video-tips",
    title: "動画作品のサンプル視聴を上手に使うコツ",
    excerpt:
      "購入前に確認したいのは、映像の質感と音のバランス。サンプル視聴で見るべきポイントをまとめました。",
    category: "使い方",
    publishedAt: "2026-09-14",
    updatedAt: "2026-09-30",
    imageUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20artwork%20of%20a%20cinema%20screen%20glow%20in%20dark%20teal%20and%20amber%2C%20geometric%20light%20rays%20and%20soft%20grain%2C%20minimal%20film%20magazine%20composition%2C%20no%20text&width=1200&height=675&seq=art-03&orientation=landscape",
    body: [
      "動画作品は、静止画のサムネイルだけでは雰囲気が伝わりにくいものです。ユメサーチでは、サンプル動画がある作品に再生ボタンを表示しています。",
      "サンプル視聴で最初に見るべきは、映像の質感です。色彩やカメラワークが好みに合うかどうかは、数秒見るだけでも判断できます。次に音のバランスを確認してください。台詞と音楽の音量比は、長時間視聴の快適さに直結します。",
      "再生ボタンを押すまで動画は読み込まれません。ページを開いた時点で重い通信が発生しないため、モバイル回線でも快適に閲覧できます。",
      "なお、掲載しているサンプル動画はデモ用の素材です。実際の作品映像ではありません。外部の正規配信ページへのリンクは、作品詳細ページの販売サイト枠に表示されます。",
    ],
    relatedWorkIds: ["WK-0001", "WK-0003", "WK-0010", "WK-0018"],
  },
  {
    slug: "similar-works-guide",
    title: "「似ている作品」機能で見つける、新しい好み",
    excerpt:
      "共通タグや作者から類似作品を探す仕組みを解説。なんとなく似ている、を言葉にする方法です。",
    category: "使い方",
    publishedAt: "2026-08-22",
    updatedAt: "2026-09-11",
    imageUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20artwork%20of%20interlocking%20geometric%20rings%20in%20sage%20green%20and%20dusty%20rose%2C%20layered%20translucent%20shapes%20with%20soft%20grain%2C%20clean%20minimal%20design%20magazine%20composition%2C%20no%20text&width=1200&height=675&seq=art-04&orientation=landscape",
    body: [
      "「なんとなく好き」という感覚は、作品選びでとても大切です。ただ、その感覚を言葉にできないと、次の作品を探すときに困ってしまいます。",
      "作品詳細ページには「この作品に似た作品を探す」ボタンがあります。共通するタグ、作者、シリーズ、作品形式を点数化し、近い順に並べる仕組みです。",
      "結果には「共通タグ3件」のように理由が表示されます。理由が見えると、自分が何に惹かれていたのかが分かりやすくなります。たとえば「静かな物語」というタグが共通していれば、次も同じ雰囲気の作品を選びやすくなります。",
      "似ている作品は、必ずしも同じジャンルから選ばれるわけではありません。作品形式が違っても雰囲気が近いことがあり、新しいジャンルに触れるきっかけにもなります。",
    ],
    relatedWorkIds: ["WK-0014", "WK-0017", "WK-0020", "WK-0009"],
  },
  {
    slug: "how-to-read-ranking",
    title: "ランキングの見方——数字だけで選ばないために",
    excerpt:
      "ランキングは入口のひとつ。集計条件と更新日時を確認して、自分に合う使い方を考えます。",
    category: "編集部コラム",
    publishedAt: "2026-07-30",
    updatedAt: "2026-09-02",
    imageUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20artwork%20of%20ascending%20bar%20shapes%20in%20warm%20sand%20and%20steel%20blue%2C%20soft%20shadow%20and%20paper%20texture%2C%20minimal%20financial%20magazine%20cover%20style%2C%20no%20text&width=1200&height=675&seq=art-05&orientation=landscape",
    body: [
      "ランキングは、はじめて作品を探すときの強い味方です。ただし、どんな指標で並んでいるのかを知らないまま使うと、自分の好みとずれてしまうことがあります。",
      "ユメサーチのランキングは、現時点ではデモデータで表示しています。販売数や閲覧数のような実績値は提供されていないため、架空の数字を作らず、編集部スコアと更新日時のみを表示しています。",
      "実データと連携したあとは、集計対象期間・指標・更新日時をあわせて表示する設計です。デイリーは短期的な注目、マンスリーは継続的な支持、編集部おすすめは傾向の異なる作品を見つける用途に向いています。",
      "ランキング上位だから自分に合うとは限りません。気になった作品は詳細ページでタグとあらすじを確認し、必要であれば比較機能で並べてみてください。",
    ],
    relatedWorkIds: ["WK-0010", "WK-0014", "WK-0020", "WK-0022"],
  },
  {
    slug: "short-or-long",
    title: "短編集と長編、どちらから読む？",
    excerpt:
      "読書時間と没入感のバランスから考える、作品の選び方。両方の良さを整理しました。",
    category: "選び方ガイド",
    publishedAt: "2026-06-18",
    updatedAt: "2026-08-14",
    imageUrl:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20artwork%20comparing%20a%20single%20small%20book%20and%20a%20tall%20stack%20of%20books%20in%20cream%20and%20deep%20charcoal%2C%20minimal%20geometric%20shapes%20and%20soft%20paper%20grain%2C%20no%20text&width=1200&height=675&seq=art-06&orientation=landscape",
    body: [
      "短編集と長編は、どちらが優れているというものではありません。目的が違うだけです。",
      "短編集の良さは、区切りが明確なことです。1話が10〜30分程度で読み終わる作品も多く、移動中や寝る前でも進められます。物語に浸りすぎず、日常に戻りやすいのも特徴です。",
      "長編の良さは、人物関係が積み上がっていくことです。序盤で張られた伏線が中盤で回収される体験は、長編ならではの楽しさです。ただし、まとまった時間が取れない時期には向いていません。",
      "ユメサーチの詳細検索には「シリーズ作品」の条件があります。単体で読める作品だけを探したいときは「単体」、じっくり読みたいときは「シリーズ」を選んでみてください。",
    ],
    relatedWorkIds: ["WK-0005", "WK-0009", "WK-0019", "WK-0026"],
  },
];